/** Public Phoenix IAR disclosure and banner. Empty or disabled values render nothing. */

export interface PhoenixPublicFinanceConfig {
  disclosureEnabled?: boolean;
  phoenixDisclosureText?: string | null;
  bannerUrl?: string | null;
}

export function phoenixFooterDisclosure(
  config: PhoenixPublicFinanceConfig | null | undefined,
): string | null {
  if (!config?.disclosureEnabled) return null;
  const text = config.phoenixDisclosureText ?? "";
  if (text.trim() === "") return null;
  return text;
}

export function phoenixBannerUrl(
  config: PhoenixPublicFinanceConfig | null | undefined,
): string | null {
  const url = config?.bannerUrl?.trim() ?? "";
  return url === "" ? null : url;
}
